import { Banner } from "@mittwald/flow-components/dist/components/Banner";
import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import React from "react";
import type { RelocationFormData } from "../../RelocationRequestWidget";
import type { TariffType } from "../steps/TariffStep/utils/TariffUtils";
import { isSingleProjectHosting } from "../steps/TariffStep/utils/TariffUtils";

export const ProjectInformationBanner: React.FC = () => {
  const form = useFormContext<RelocationFormData>();
  const tariffType = form.watch("target.product") as TariffType;

  const bannerType = isSingleProjectHosting(tariffType)
    ? "emptyProjectRequiredBanner"
    : "createNewProjectBanner";

  return (
    <Banner
      description={`${bannerType}.description`}
      headline={`${bannerType}.headline`}
    />
  );
};
